import { mapEventToGA4Ecommerce } from '../gtm/ga4-ecommerce';
import { mapEventToElalDataLayer, toElalNativeMessage } from '../gtm/elal-events';

const NATIVE_MESSAGE_TYPE_EVENT = 'firebase_event';

// The legacy EXECUTED_SEARCH mapping below already sends search_hotel natively,
// so the new web-only search_hotel signal would duplicate it in the app.
const NATIVE_SKIPPED_EVENTS = ['SEARCH_RESULTS_LANDED'];

// A lazy-recheck Book click is the same native add_to_cart as any other Book click.
const NATIVE_EVENT_ALIASES = {
    SELECTED_LAZY_RECHECK_DEAL: 'SELECTED_DEAL',
};

const MOBILE_EVENT_NAME_MAP = {
    EXECUTED_SEARCH: 'search_hotel',
    SEARCH_WITHOUT_RESULTS: 'search_hotel',
    SEARCH_WITHOUT_RESULTS_HOTEL: 'search_hotel',
    RESULTS_RECEIVED_HOTELS: 'view_item_list',
    SELECTED_HOTEL: 'select_item',
    VIEWED_HOTEL_PAGE: 'view_item',
    SELECTED_DEAL: 'add_to_cart',
    PROCEEDED_TO_PAYMENT_OPEN_PAYMENT_FORM: 'begin_checkout',
    BOOKING_CREATED: 'purchase',
    RESERVATION_CANCELED: 'refund',
};

const PAGE_TYPE_MAP = {
    search_hotel: 'search hotel page',
    view_item_list: 'hotel results page',
    select_item: 'hotel results page',
    view_item: 'hotel page',
    add_to_cart: 'hotel page',
    begin_checkout: 'hotel page',
    purchase: 'hotel page',
    refund: 'my bookings',
};

function isElalMobileWebview() {
    return typeof navigator !== 'undefined' && navigator.userAgent.includes('ElalMobile');
}

function toFirebaseMobileEvent(event_name, properties) {
    const mobileName = MOBILE_EVENT_NAME_MAP[event_name];
    const ga4 = mapEventToGA4Ecommerce(event_name, properties);
    if (!ga4) return null;

    const { event: _event, event_name: _event_name, ecommerce, email: _email, ...rest } = ga4;

    const params = {
        category: 'EL AL Travel',
        process: 'arbitrip funnel',
        page_url: typeof window !== 'undefined' ? window.location.href : undefined,
        page_type: PAGE_TYPE_MAP[mobileName],
        ...rest,
        ...(ecommerce || {}),
    };

    Object.keys(params).forEach((k) => {
        if (params[k] === undefined || params[k] === null) delete params[k];
    });

    return { name: mobileName, params };
}

function toNativeMessage(event_name, properties) {
    // Funnel events keep their existing native payload until the app team accepts the new contract.
    if (MOBILE_EVENT_NAME_MAP[event_name]) {
        const firebaseEvent = toFirebaseMobileEvent(event_name, properties);
        return firebaseEvent && { type: NATIVE_MESSAGE_TYPE_EVENT, payload: firebaseEvent };
    }
    if (NATIVE_SKIPPED_EVENTS.includes(event_name)) return null;
    return toElalNativeMessage(mapEventToElalDataLayer(event_name, properties));
}

export function startSession() {}

export function trackEvent(event_name, properties) {
    try {
        if (!isElalMobileWebview()) return;
        if (typeof window === 'undefined') return;

        const message = toNativeMessage(NATIVE_EVENT_ALIASES[event_name] || event_name, properties);
        if (!message) return;

        window.postMessage(JSON.stringify(message), '*');
    } catch (_err) {
        // intentionally ignored
    }
}

export function endSession() {}
